import { render, staticRenderFns } from "./ClientAppointmentForm.vue?vue&type=template&id=0b6a264e"
import script from "./ClientAppointmentForm.vue?vue&type=script&lang=ts"
export * from "./ClientAppointmentForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientAppointmentForm.vue?vue&type=style&index=0&id=0b6a264e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports